import ListBullet from 'assets/format_list_bulleted.svg'
import { Menu, MenuItem, IconButton } from '@mui/material'
import { type GridRenderCellParams } from '@mui/x-data-grid'
import { useState } from 'react'
import { type LicensedEstablishmentUser } from 'types/api'

export const DeleteLEConnectUserRenderCell = ({
  params,
  setLEUserRowData,
}: {
  params: GridRenderCellParams<LicensedEstablishmentUser>
  setLEUserRowData: React.Dispatch<
    React.SetStateAction<LicensedEstablishmentUser | null | undefined>
  >
}) => {
  const [anchorEl, setAnchorEl] = useState<Element | null>(null)

  const handleMenuOpen = (event: React.SyntheticEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <IconButton onClick={handleMenuOpen}>
        <img src={ListBullet} width={4} height={16} alt="options icon" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem
          onClick={() => {
            setLEUserRowData(params.row)
            handleMenuClose()
          }}
        >
          Delete J&J Connect User
        </MenuItem>
      </Menu>
    </>
  )
}
